var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAexTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.016,
    height: 402.199,
    viewBox: "0 0 258.016 402.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.951,79H92.065a12.409,12.409,0,0,0,0,24.818h73.886a12.409,12.409,0,1,0,0-24.818Z",
    fill: "#FEF154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.317,341.5v-.011h.011a53.122,53.122,0,0,0,53.12-53.125V98.657a53.123,53.123,0,0,0-53.12-53.126h0V17.8a45.72,45.72,0,0,1,18.693,12.559h18.7A60.674,60.674,0,0,0,182.149,0H75.892a60.66,60.66,0,0,0-52.57,30.358h18.7A45.662,45.662,0,0,1,60.715,17.8V45.531A53.124,53.124,0,0,0,7.589,98.657V288.364a53.126,53.126,0,0,0,53.119,53.125L0,402.2H22.707L60.72,364.186v.071h136.6V364.2l38,38h22.7ZM75.892,15.179H182.144l0,30.352H75.892ZM101.817,285.61H84.382a15.174,15.174,0,1,1,0-30.348h17.435a15.174,15.174,0,0,1,0,30.348Zm71.817,0H156.2a15.174,15.174,0,1,1,0-30.348h17.436a15.174,15.174,0,1,1,0,30.348Zm10.653-69.437H73.728a15.663,15.663,0,0,1-15.563-13.908L42.546,83.405a19.961,19.961,0,0,1,19.835-22.2H195.633a19.962,19.962,0,0,1,19.837,22.2l-15.619,118.86A15.663,15.663,0,0,1,184.287,216.173Z",
    fill: "#FEF154"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAexTrain);
export default __webpack_public_path__ + "static/media/aex_train.25578c0c0f045405675fbe778fcf28f4.svg";
export { ForwardRef as ReactComponent };